export default __webpack_public_path__ + "static/media/markUnreadIcon.46ac943f.svg";